module.exports = __webpack_public_path__ + "static/img/NOTTINGHAM-OAK.3e369f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/NOTTINGHAM-OAK.png
// module id = XSLe
// module chunks = 0